import React, { useRef, useState } from "react";
import styled from "styled-components";
import Plus from "@untitled-ui/icons-react/build/esm/Plus";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import File06 from "@untitled-ui/icons-react/build/esm/File06";
import Microphone01 from "@untitled-ui/icons-react/build/esm/Microphone01";
import XClose from "@untitled-ui/icons-react/build/esm/XClose";
import NanaBoLogo from "../../../../assets/images/nanaBOLogoWhite.png";
import TooltipSimple from "../../../common/tooltip/TooltipSimple";
import { DASHBOARD_HERO_CONFIG } from "./dashboardConfig";

// #region SCOPED CSS
const StyledDashboardHero = styled.section`
    flex: 1 1 0;
    width: 100%;
    min-height: 320px;
    border-radius: 6px;
    background: ${props => props.$gradientBg || DASHBOARD_HERO_CONFIG.gradientBackground};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 24px;
    box-sizing: border-box;
    overflow: hidden;

    .hero-greeting {
        color: #ffffff;
        font-size: 26px;
        font-weight: 700;
        line-height: 31px;
        margin: 0 0 20px;
        text-align: center;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }

    .prompt-card {
        width: 100%;
        max-width: 572px;
        min-height: 118px;
        background: var(--backgrounds-lines-n-600, #10141b);
        border: none;
        border-radius: 20px;
        padding: 18px 20px 16px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.32);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;
    }

    .prompt-input-area {
        width: 100%;
        height: 24px;
        background: transparent;
        border: none;
        outline: none;
        color: var(--text-icons-gray-200, #7c868b);
        font-size: 14px;
        line-height: 20px;
        font-family: inherit;
        padding: 0;
        opacity: 1;
        cursor: not-allowed;
        -webkit-text-fill-color: var(--text-icons-gray-200, #7c868b);

        &::placeholder {
            color: var(--text-icons-gray-200, #7c868b);
            opacity: 1;
        }
    }

    .prompt-toolbar {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
    }

    .icon-btn {
        background: transparent;
        border: none;
        outline: none;
        color: var(--text-icons-gray-200, #7c868b);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 2px;
        cursor: not-allowed;

        svg {
            width: 16px;
            height: 16px;
        }
    }

    .add-file-btn {
        border-radius: 4px;
        cursor: pointer;
        flex-shrink: 0;
        transition:
            color 0.2s,
            background-color 0.2s;

        &:hover,
        &:focus-visible {
            color: var(--text-icons-gray-100, #d1d1d1);
            background: var(--backgrounds-lines-n-400, #1e2631);
        }
    }

    .add-file-btn.disabled {
        //opacity: 0.5;
        cursor: not-allowed;

        &:hover,
        &:focus-visible {
            color: var(--text-icons-gray-200, #7c868b);
            background: transparent;
        }
    }

    .file-input {
        display: none;
    }

    .selected-files-scroll {
        display: flex;
        flex: 1;
        align-items: center;
        gap: 6px;
        min-width: 0;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 2px 0 4px;
        scrollbar-width: thin;

        &:empty {
            padding: 0;
        }
    }

    .selected-file {
        display: flex;
        flex: 0 0 150px;
        align-items: center;
        gap: 6px;
        min-width: 0;
        height: 30px;
        padding: 3px 6px 3px 4px;
        color: var(--text-icons-gray-100, #d1d1d1);
        background: var(--backgrounds-lines-n-400, #1e2631);
        border: 1px solid var(--backgrounds-lines-n-100, #3c485a);
        border-radius: 8px;
        box-sizing: border-box;
    }

    .selected-file-icon-container {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        color: #ffffff;
        background: #6123e4;
        border-radius: 50%;
        flex-shrink: 0;
    }

    .selected-file-icon {
        width: 12px;
        height: 12px;
    }

    .selected-file-name {
        display: block;
        min-width: 0;
        overflow: hidden;
        font-size: 11px;
        line-height: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .remove-file-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        padding: 1px;
        color: var(--text-icons-gray-200, #7c868b);
        background: transparent;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        flex-shrink: 0;

        &:hover,
        &:focus-visible {
            color: var(--text-icons-red-500, #ff3636);
            background: var(--backgrounds-lines-n-600, #10141b);
        }

        svg {
            width: 12px;
            height: 12px;
        }
    }

    .selector-pill {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        color: var(--text-icons-gray-200, #7c868b);
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
        background: transparent;
        border: none;
        outline: none;
        cursor: not-allowed;
        padding: 2px 0;

        svg {
            width: 14px;
            height: 14px;
        }
    }

    .hero-nanabo-logo {
        display: block;
        width: 78px;
        height: auto;
        margin-top: 20px;
    }
`;
// #endregion

// #region CONSTANTS
const ACCEPTED_FILE_EXTENSIONS = [".xls", ".xlsx", ".csv", ".pdf"];
const ACCEPTED_FILE_TYPES = ACCEPTED_FILE_EXTENSIONS.join(",");
// #endregion

export default function DashboardHero({ userName, gradientBg }) {
    // #region VARS
    const displayName = userName || DASHBOARD_HERO_CONFIG.defaultUserName;
    const fileInputRef = useRef(null);
    // #endregion

    // #region STATES
    const [selectedFiles, setSelectedFiles] = useState([]);
    // #endregion

    // #region METHODS
    const handleFileSelection = event => {
        const acceptedFiles = Array.from(event.target.files || []).filter(file => {
            const normalizedFileName = file.name.toLowerCase();
            return ACCEPTED_FILE_EXTENSIONS.some(extension => normalizedFileName.endsWith(extension));
        });

        setSelectedFiles(currentFiles => {
            const currentFileIDs = new Set(currentFiles.map(file => file.id));
            const newFiles = acceptedFiles
                .map(file => ({
                    id: `${file.name}-${file.size}-${file.lastModified}`,
                    name: file.name,
                    file
                }))
                .filter(file => !currentFileIDs.has(file.id));

            return [...currentFiles, ...newFiles];
        });

        event.target.value = "";
    };

    const removeSelectedFile = fileID => {
        setSelectedFiles(currentFiles => currentFiles.filter(file => file.id !== fileID));
    };
    // #endregion

    // #region RENDER
    return (
        <StyledDashboardHero $gradientBg={gradientBg} className="dashboard-hero-container">
            <h1 className="hero-greeting">
                {DASHBOARD_HERO_CONFIG.greetingPrefix} {displayName}?
            </h1>

            <div className="prompt-card">
                <input
                    type="text"
                    className="prompt-input-area"
                    placeholder={DASHBOARD_HERO_CONFIG.inputPlaceholder}
                    disabled
                    readOnly
                />

                <div className="prompt-toolbar">
                    <button
                        type="button"
                        className="icon-btn add-file-btn disabled"
                        disabled={true}
                        aria-label="Select Excel, CSV or PDF files"
                        onClick={() => fileInputRef.current?.click()}>
                        <Plus />
                    </button>

                    <input
                        ref={fileInputRef}
                        type="file"
                        className="file-input"
                        accept={ACCEPTED_FILE_TYPES}
                        multiple
                        onChange={handleFileSelection}
                    />

                    <div className="selected-files-scroll" aria-live="polite">
                        {selectedFiles.map(file => (
                            <div className="selected-file" key={file.id}>
                                <span className="selected-file-icon-container">
                                    <File06 className="selected-file-icon" />
                                </span>

                                <TooltipSimple title={file.name} width="280px" color="var(--backgrounds-lines-n-100)">
                                    <span className="selected-file-name">{file.name}</span>
                                </TooltipSimple>

                                <button
                                    type="button"
                                    className="remove-file-btn"
                                    aria-label={`Remove ${file.name}`}
                                    onClick={() => removeSelectedFile(file.id)}>
                                    <XClose />
                                </button>
                            </div>
                        ))}
                    </div>

                    <div className="toolbar-right">
                        <button type="button" className="selector-pill" disabled>
                            <span>{DASHBOARD_HERO_CONFIG.selectorLabel}</span>
                            <ChevronDown />
                        </button>

                        <button type="button" className="icon-btn" aria-label="Voice input" disabled>
                            <Microphone01 />
                        </button>
                    </div>
                </div>
            </div>

            <img src={NanaBoLogo} className="hero-nanabo-logo" alt="nanaBO" />
        </StyledDashboardHero>
    );
    // #endregion
}
